<template>
<svg :data-type="type" id="copyIcon" style="cursor: pointer !important" width="42" height="34" viewBox="0 0 42 34" fill="none" xmlns="http://www.w3.org/2000/svg">
<path class="first" d="M0.472656 0.563477H36.4727C39.2341 0.563477 41.4727 2.80205 41.4727 5.56348V28.5635C41.4727 31.3249 39.2341 33.5635 36.4727 33.5635H0.472656V0.563477Z" fill="white"/>
<path class="second" d="M23.4727 8.31348H14.4727C13.6477 8.31348 12.9727 8.98848 12.9727 9.81348V20.3135H14.4727V9.81348H23.4727V8.31348ZM22.7227 11.3135L27.2227 15.8135V23.3135C27.2227 24.1385 26.5477 24.8135 25.7227 24.8135H17.4652C16.6402 24.8135 15.9727 24.1385 15.9727 23.3135L15.9802 12.8135C15.9802 11.9885 16.6477 11.3135 17.4727 11.3135H22.7227ZM21.9727 16.5635H26.0977L21.9727 12.4385V16.5635Z" fill="#8E96F7"/>
</svg>



</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'text'
        }
    }
}
</script>

<style lang="scss" scoped>
svg#copyIcon {
    cursor: default !important;
    border: 1px solid #fff;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    background: #fff;
    height: 33px;

    &[data-type="banner"] {
        background: #727CF5;
        border: 1px solid #727CF5;
        path.first {
                fill: #727CF5 !important;
            
        }
        path.second {
            fill: #fff !important;
        }
    }
}
</style>